import React from 'react';
import PropTypes from 'prop-types';
import styles from './CircleOption.module.less';
import classNames from 'classnames';
import { TOP } from '../Popup/alignments';
import Tooltip from '../Popup/Tooltip';

export default function CircleOption({
  selected,
  onClick,
  tooltipContent,
  name,
  type,
  disabled,
  dataTestId,
}) {
  return (
    <Tooltip
      alignment={TOP}
      spacing={0}
      ignorePadding={true}
      content={tooltipContent}
    >
      <div
        className={classNames(
          styles.wrapper,
          selected && styles.selected,
          disabled && styles.disabled
        )}
        data-testid={dataTestId}
        onClick={onClick}
      >
        <div
          className={classNames(
            styles.circleOption,
            styles[type],
            styles[name]
          )}
        />
      </div>
    </Tooltip>
  );
}

CircleOption.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string,
  selected: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
};
